// What each HR upload accepts. Mirrors the backend rules in app/services/hr_file_service.py, which
// enforce them again (and check that the file's contents really are that type); here they set the
// file picker's filter and stop a wrong file before it is sent.
const MB = 1024 * 1024;
const PDF = ['.pdf'];
const IMAGE = ['.jpg', '.jpeg', '.png'];
const PDF_OR_IMAGE = [...PDF, ...IMAGE];

const rule = (label, extensions, maxMb) => ({ label, extensions, max: maxMb * MB, accept: extensions.join(',') });

export const PHOTO_RULE = rule('Profile photo', IMAGE, 2);
export const LEAVE_ATTACHMENT_RULE = rule('Leave attachment', PDF_OR_IMAGE, 5);
export const CHECKLIST_RULE = rule('Checklist document', PDF_OR_IMAGE, 10);
export const REQUEST_ATTACHMENT_RULE = rule('Request attachment', PDF_OR_IMAGE, 10);   // HR Request Center

// a document's scan, by its document type; anything not listed takes "other"
export const DOCUMENT_RULES = {
  cv: rule('CV / Résumé', PDF, 10),
  offer_letter: rule('Offer letter', PDF, 10),
  appointment_letter: rule('Appointment letter', PDF, 10),
  contract: rule('Signed contract', PDF, 10),
  pension_form: rule('Pension form', PDF, 10),
  id_card: rule('Means of identification', PDF_OR_IMAGE, 10),
  certificate: rule('Certificate', PDF_OR_IMAGE, 10),
  passport: rule('Passport', PDF_OR_IMAGE, 10),
  visa: rule('Visa', PDF_OR_IMAGE, 10),
  work_permit: rule('Work permit', PDF_OR_IMAGE, 10),
  residence_permit: rule('Residence permit', PDF_OR_IMAGE, 10),
  cerpac: rule('CERPAC', PDF_OR_IMAGE, 10),
  drivers_license: rule("Driver's licence", PDF_OR_IMAGE, 10),
  guarantor_form: rule('Guarantor form', PDF_OR_IMAGE, 10),
  reference_letter: rule('Reference letter', PDF_OR_IMAGE, 10),
  bank_proof: rule('Bank proof', PDF_OR_IMAGE, 10),
  hmo_form: rule('HMO form', PDF_OR_IMAGE, 10),
  medical: rule('Medical fitness', PDF_OR_IMAGE, 10),
  other: rule('Document', PDF_OR_IMAGE, 10),
};

export const documentRule = type => DOCUMENT_RULES[String(type || '').toLowerCase()] || DOCUMENT_RULES.other;

// same wording and order as the backend's messages
export const kinds = r => [['.pdf', 'PDF'], ['.png', 'PNG'], ['.jpg', 'JPEG']].filter(([e]) => r.extensions.includes(e)).map(([, k]) => k).join(', ');
export const fmtSize = n => (n >= MB ? `${+(n / MB).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
export const ruleHint = r => `${kinds(r)} only, max ${fmtSize(r.max)}`;

// null when the file is fine, otherwise the reason it is refused
export function checkFile(file, r) {
  const ext = `.${String(file.name).split('.').pop().toLowerCase()}`;
  if (!file.name.includes('.') || !r.extensions.includes(ext)) return `${r.label} must be ${kinds(r)} — ${file.name} is not accepted.`;
  if (file.size > r.max) return `${file.name} is ${fmtSize(file.size)}; ${r.label.toLowerCase()} must be ${fmtSize(r.max)} or smaller.`;
  return null;
}
